'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = exports.serveUpsell = undefined;

require('slick-carousel');

// Cart Upsell Variables
var $dom = {};
var leftBlackArrow = '';
var rightBlackArrow = '';

var variantArray = [];
var firstServe = false;
var upsellLoaded = false;
var upsellOneActive = false;
var upsellTwoActive = false;
var toggleLock = false;
var toggleLock2 = false;

var cacheDom = function cacheDom() {
  // $dom.cartUpsellAll = $('.js-inline-cart-recommendations');
  // $dom.cartUpsellAjax = $('[data-cart-upsell="liquid"]');
  $dom.cartUpsellDy = $('[data-cart-upsell="dy-rec"]');
};

var resetCartUpsells = function resetCartUpsells() {
  firstServe = false;
  upsellLoaded = false;
  $('.js-inline-cart-recommendations').removeClass('is-hidden');
  $('[data-cart-upsell="liquid"]').removeClass('is-active');
  $('[data-cart-upsell="dy-rec"]').removeClass('is-active');
  $('[data-cart-upsell="liquid"]').html('');
  clearVariantArray();
};

var clearVariantArray = function clearVariantArray() {
  variantArray = [];
};

/*
  *  Attempt to serve upsell on load if cart qualifies.
  *  Step 1. Check if upsell already loaded. If loaded return.
  *  Step 2. Check cart contents for which case to serve
  *  Step 3. Set variables to prevent serving again
  *
  *
  *
  *
  *   Case 1) Single item - only mens watch or only womens watch
  *           1. Ajax load in product.ajax-upsell.liquid
  *           2. Check if ajax loaded section has products
  *           2a. If has products init slider
  *           2b. If has no products proceed to Case 2
  *           3. Set variables
  *
  *  Case 2) 2 Products
  *
  *          3.Set DY recommended products to visible
  *
  *          z. Set variables
  *
  * * * * * * * * * * ** * ** * ** * * * * * * * * * * * * * * */
// eslint-disable-next-line consistent-return
var serveUpsell = exports.serveUpsell = function serveUpsell(cart) {

  // Cart is empty on page load or all items have been removed from cart
  if (cart.item_count === 0) {
    return resetCartUpsells();
  }

  // Check if upsell already loaded. If loaded return.
  if (firstServe && !upsellLoaded) {
    return false;
  }

  if (upsellLoaded) {
    // Some upsell is already loaded. Check if we need to toggle upsells
    if (toggleLock === false) {
      toggleLock = true;
      toggleUpsell(cart);
    }
    return false;
  }

  // Step 2. Check cart contents for which case to serve
  if (cart.item_count === 1) {
    var singleProduct = cart.items[0];

    serveUpsellCase1(singleProduct);
  } else if (cart.item_count > 1) {
    serveUpsellCase2();
  }

  // Step 3. Set variables to prevent serving again
  if (firstServe === false) {
    firstServe = true;
  }
};

var verifyAjaxUpsell = function verifyAjaxUpsell() {
  // Ajax upsell should be loaded
  if ($('.cart-strap-slider .strap-upsell').length) {
    setTimeout(function () {
      $('.js-cart-strap-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: '<div class="slick-prev"><img src="' + leftBlackArrow + '"/></div>',
        nextArrow: '<div class="slick-next"><img src="' + rightBlackArrow + '"/></div>'
      });
    }, 110);

    $dom.cartUpsell_ajax.addClass('is-loading is-active');
    $dom.cartUpsell_dy.addClass('is-loading').removeClass('is-active');

    setTimeout(function () {
      $dom.cartUpsell_ajax.removeClass('is-loading');
      $dom.cartUpsell_dy.removeClass('is-loading');
    }, 300);
  } else {
    serveUpsellCase2();
  }
};

// Ajax Load this product's upsell products
var serveUpsellCase1 = function serveUpsellCase1(product) {
  if (product.product_type === 'Men\'s Watch' || product.product_type === 'Women\'s Watch') {
    var upsellEntry = $('[data-cart-upsell=liquid]');
    // Ajax load upsell.
    var requestUrl = '/products/' + product.handle + '?view=ajax-upsell';

    $.get(requestUrl, function (response) {
      upsellEntry.html(response);
      window.Flow.localize();
      verifyAjaxUpsell();
    }).done(function () {
      $(window).trigger('resize');
    });

    if (upsellLoaded === false) {
      upsellLoaded = true;
    }

    upsellOneActive = true;
    upsellTwoActive = false;
  } else {
    serveUpsellCase2();
  }
  setTimeout(function () {
    $(window).trigger('resize');
  }, 250);
};

// Show DY Product Recs
var serveUpsellCase2 = function serveUpsellCase2() {
  $dom.cartUpsell_ajax.addClass('is-loading').removeClass('is-active');
  $dom.cartUpsell_dy.addClass('is-loading is-active');
  setTimeout(function () {
    $dom.cartUpsell_ajax.removeClass('is-loading');
    $dom.cartUpsell_dy.removeClass('is-loading');
    $(window).trigger('resize');
    $('.js-inline-cart-recs-slider.slick-slider').slick('slickGoTo', 0);
  }, 300);

  if (upsellLoaded === false) {
    upsellLoaded = true;
  }

  upsellOneActive = false;
  upsellTwoActive = true;

  $(window).trigger('resize');
  $('.js-inline-cart-recs-slider.slick-slider').slick('slickGoTo', 0);

  setTimeout(function () {
    $('.js-inline-cart-recs-slider.slick-slider').slick('slickGoTo', 0);
    setTimeout(function () {
      $('.js-inline-cart-recs-slider.slick-slider').slick('slickGoTo', 0);
    }, 3500);
  }, 150);
};

var toggleUpsell = function toggleUpsell(cart) {
  if (toggleLock2 === false) {
    toggleLock2 = true;
    if (cart.item_count === 1) {
      if (upsellTwoActive) {
        clearVariantArray();
        var singleProduct = cart.items[0];

        serveUpsellCase1(singleProduct);
      }
    } else if (cart.item_count > 1) {
      if (upsellOneActive) {
        clearVariantArray();
        serveUpsellCase2();
      }
    }
  }

  setTimeout(function () {
    toggleLock = false;
    toggleLock2 = false;
  }, 150);
};

var bindUIActions = function bindUIActions() {

  $('[data-cart-upsell="liquid"]').on('click', '[data-cart-upsell-atc]', function () {
    if (variantArray.length) {
      variantArray.forEach(function (id) {

        // needs to be changed to cart controls
        InlineCart.addLineItem(id, 1);
        //
      });

      $('.js-inline-cart-recommendations').addClass('is-hidden');
    }
  });

  $('[data-cart-upsell="liquid"]').on('click', '.js-add-upsell-item', function (_ref) {
    var self = _ref.currentTarget;

    var $self = $(self);

    if ($self.hasClass('strap-upsell--selected')) {
      $self.removeClass('strap-upsell--selected');
    } else {
      $self.addClass('strap-upsell--selected');
    }

    var variantID = $self.attr('data-variant-id');
    var foundIndex = $.inArray(variantID, variantArray);

    if (foundIndex >= 0) {
      variantArray.splice(foundIndex, 1);
    } else {
      variantArray.push(variantID);
    }
  });

  $('[data-cart-upsell="dy-rec"]').on('click', '.add-to-cart.dy-cart-recs-product__cta', function (_ref2) {
    var self = _ref2.currentTarget,
        event = _ref2.event;

    event.preventDefault();
    var $self = $(self);

    // needs to be changed to cart controls
    InlineCart.addLineItem($self.attr('data-variant-id'), 1);
    //

    $('.js-inline-cart-recommendations').addClass('is-hidden');
  });
};

var init = exports.init = function init() {
  cacheDom();
  bindUIActions();
};

exports.default = {
  init: init,
  serveUpsell: serveUpsell
};

// (function (InlineCartRecs, $) {

//   // Cart Upsell Variables
//   const $dom = {};
//   const leftBlackArrow = '';
//   const rightBlackArrow = '';

//   let variantArray = [];
//   let firstServe = false;
//   let upsellLoaded = false;
//   let upsell_1_Active = false;
//   let upsell_2_Active = false;
//   let toggleLock = false;
//   let toggleLock2 = false;

//   const cacheDom = () => {
//     $dom.cartUpsell_all = $('.js-inline-cart-recommendations');
//     $dom.cartUpsell_ajax = $('[data-cart-upsell="liquid"]');
//     $dom.cartUpsell_dy = $('[data-cart-upsell="dy-rec"]');
//   };

//   const resetCartUpsells = () => {
//     firstServe = false;
//     upsellLoaded = false;
//     $dom.cartUpsell_all.removeClass('is-hidden');
//     $dom.cartUpsell_ajax.removeClass('is-active');
//     $dom.cartUpsell_dy.removeClass('is-active');
//     $dom.cartUpsell_ajax.html('');
//     clearVariantArray();
//   };

//   const clearVariantArray = () => {
//     variantArray = [];
//   };

//   // add array of variant IDs for flow
//   const getArrayItems = function (array) {
//     return array.map(function (variantId) {
//       return {
//         id: variantId,
//         quantity: 1,
//       };
//     });
//   };
//   /*
//    *  Attempt to serve upsell on load if cart qualifies.
//    *  Step 1. Check if upsell already loaded. If loaded return.
//    *  Step 2. Check cart contents for which case to serve
//    *  Step 3. Set variables to prevent serving again
//    *
//    *
//    *
//    *
//    *   Case 1) Single item - only mens watch or only womens watch
//    *           1. Ajax load in product.ajax-upsell.liquid
//    *           2. Check if ajax loaded section has products
//    *           2a. If has products init slider
//    *           2b. If has no products proceed to Case 2
//    *           3. Set variables
//    *
//    *  Case 2) 2 Products
//    *
//    *          3.Set DY recommended products to visible
//    *
//    *          z. Set variables
//    *
//    * * * * * * * * * * ** * ** * ** * * * * * * * * * * * * * * */
//   const serveUpsell = cart => {

//     // Cart is empty on page load or all items have been removed from cart
//     if (cart.item_count == 0) {
//       return resetCartUpsells();
//     }

//     // Check if upsell already loaded. If loaded return.
//     if (firstServe && !upsellLoaded) {
//       return false;
//     }

//     if (upsellLoaded) {
//       // Some upsell is already loaded. Check if we need to toggle upsells
//       if (toggleLock == false) {
//         toggleLock = true;
//         toggleUpsell(cart);
//       }
//       return false;
//     }

//     // Step 2. Check cart contents for which case to serve
//     if (cart.item_count == 1) {
//       const singleProduct = cart.items[0];

//       serveUpsellCase1(singleProduct);
//     } else if (cart.item_count > 1) {
//       serveUpsellCase2();
//     }

//     // Step 3. Set variables to prevent serving again
//     if (firstServe == false) {
//       firstServe = true;
//     }
//   };

//   const verifyAjaxUpsell = () => {
//     // Ajax upsell should be loaded
//     if ($('.cart-strap-slider .strap-upsell').length) {
//       setTimeout(function () {
//         $('.js-cart-strap-slider').slick({
//           slidesToShow: 3,
//           slidesToScroll: 1,
//           arrows: true,
//           prevArrow: '<div class="slick-prev"><img src="' + leftBlackArrow + '"/></div>',
//           nextArrow: '<div class="slick-next"><img src="' + rightBlackArrow + '"/></div>',
//         });
//       }, 110);
//       $dom.cartUpsell_ajax.addClass('is-loading is-active');
//       $dom.cartUpsell_dy.addClass('is-loading').removeClass('is-active');
//       setTimeout(function () {
//         $dom.cartUpsell_ajax.removeClass('is-loading');
//         $dom.cartUpsell_dy.removeClass('is-loading');
//       }, 300);
//     } else {
//       serveUpsellCase2();
//     }
//   };

//   // Ajax Load this product's upsell products
//   const serveUpsellCase1 = product => {
//     if (product.product_type == 'Men\'s Watch' || product.product_type == 'Women\'s Watch') {
//       const upsellEntry = $('[data-cart-upsell=liquid]');
//       // Ajax load upsell.
//       const requestUrl = '/products/' + product.handle + '?view=ajax-upsell';

//       $.get(requestUrl, function (response) {
//         upsellEntry.html(response);
//         Flow.localize();
//         verifyAjaxUpsell();
//       }).done(function () {
//         $(window).trigger('resize');
//       });
//       if (upsellLoaded == false) {
//         upsellLoaded = true;
//       }
//       upsell_1_Active = true;
//       upsell_2_Active = false;
//     } else {
//       serveUpsellCase2();
//     }
//     setTimeout(function () {
//       $(window).trigger('resize');
//     }, 250);
//   };

//   // Show DY Product Recs
//   const serveUpsellCase2 = () => {
//     $dom.cartUpsell_ajax.addClass('is-loading').removeClass('is-active');
//     $dom.cartUpsell_dy.addClass('is-loading is-active');
//     setTimeout(function () {
//       $dom.cartUpsell_ajax.removeClass('is-loading');
//       $dom.cartUpsell_dy.removeClass('is-loading');
//       $(window).trigger('resize');
//       $('.js-inline-cart-recs-slider.slick-slider').slick('slickGoTo', 0);
//     }, 300);
//     if (upsellLoaded == false) {
//       upsellLoaded = true;
//     }
//     upsell_1_Active = false;
//     upsell_2_Active = true;
//     $(window).trigger('resize');
//     $('.js-inline-cart-recs-slider.slick-slider').slick('slickGoTo', 0);
//     setTimeout(function () {
//       $('.js-inline-cart-recs-slider.slick-slider').slick('slickGoTo', 0);
//       setTimeout(function () {
//         $('.js-inline-cart-recs-slider.slick-slider').slick('slickGoTo', 0);
//       }, 3500);
//     }, 150);
//   };


//   const toggleUpsell = cart => {
//     if (toggleLock2 == false) {
//       toggleLock2 = true;
//       if (cart.item_count == 1) {
//         if (upsell_2_Active) {
//           clearVariantArray();
//           const singleProduct = cart.items[0];

//           serveUpsellCase1(singleProduct);
//         }
//       } else if (cart.item_count > 1) {
//         if (upsell_1_Active) {
//           clearVariantArray();
//           serveUpsellCase2();
//         }
//       }
//     }
//     setTimeout(function () {
//       toggleLock = false;
//       toggleLock2 = false;
//     }, 150);
//   };


//   const bindUIActions = () => {

//     $('[data-cart-upsell="liquid"]').on('click', '[data-cart-upsell-atc]', function () {
//       if (variantArray.length) {
//         // if (Helpers.isFlow()) {
//         //   InlineCart.addItems(getArrayItems(variantArray));
//         // } else {
//         variantArray.forEach(function (id) {
//           InlineCart.addLineItem(id, 1);
//         });
//         // }
//         $dom.cartUpsell_all.addClass('is-hidden');
//       }
//     });

//     $('[data-cart-upsell="liquid"]').on('click', '.js-add-upsell-item', function () {
//       const $self = $(this);

//       if ($self.hasClass('strap-upsell--selected')) {
//         $self.removeClass('strap-upsell--selected');
//       } else {
//         $self.addClass('strap-upsell--selected');
//       }

//       const variantID = $self.attr('data-variant-id');
//       const foundIndex = $.inArray(variantID, variantArray);

//       if (foundIndex >= 0) {
//         variantArray.splice(foundIndex, 1);
//       } else {
//         variantArray.push(variantID);
//       }
//     });

//     $('[data-cart-upsell="dy-rec"]').on('click', '.add-to-cart.dy-cart-recs-product__cta', function (event) {
//       event.preventDefault();
//       const $self = $(this);

//       InlineCart.addLineItem($self.attr('data-variant-id'), 1);
//       $dom.cartUpsell_all.addClass('is-hidden');
//     });

//   };

//   InlineCartRecs.init = function () {
//     cacheDom();
//     bindUIActions();
//   };

//   InlineCartRecs.serveUpsell = serveUpsell;

// }(window.InlineCartRecs = window.InlineCartRecs || {}, jQuery));